// extracted by mini-css-extract-plugin
export default {"sannerPopup":"ScanPopup_sannerPopup__-2s2x","reader":"ScanPopup_reader__S8IMK","btns":"ScanPopup_btns__jx4Q8","scanArea":"ScanPopup_scanArea__BucuD"};